import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppNotification, NotificationType } from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<AppNotification[]>([]);
  public notifications$: Observable<AppNotification[]> = this.notificationsSubject.asObservable();
  
  private unreadCountSubject = new BehaviorSubject<number>(0);
  public unreadCount$: Observable<number> = this.unreadCountSubject.asObservable();

  private toastSubject = new BehaviorSubject<AppNotification | null>(null);
  public toast$ = this.toastSubject.asObservable();

  constructor() {
    this.loadMockNotifications();
  }

  private loadMockNotifications(): void {
    const initialNotifications: AppNotification[] = [
      {
        id: '1',
        title: 'تبرع جديد',
        message: 'تم استلام تبرع جديد بقيمة 500 جنيه',
        type: NotificationType.SUCCESS,
        recipientRole: 'SUPER_ADMIN',
        isRead: false,
        createdAt: new Date()
      }
    ];
    this.notificationsSubject.next(initialNotifications);
    this.updateUnreadCount();
  }

  getNotifications(): Observable<AppNotification[]> {
    return this.notifications$;
  }

  markAsRead(id: string): void {
    const current = this.notificationsSubject.value;
    const updated = current.map(notif => 
      notif.id === id ? { ...notif, isRead: true } : notif
    );
    this.notificationsSubject.next(updated);
    this.updateUnreadCount();
  }

  removeNotification(id: string): void {
    const current = this.notificationsSubject.value;
    const updated = current.filter(notif => notif.id !== id);
    this.notificationsSubject.next(updated);
    this.updateUnreadCount();
  }

  addNotification(notification: AppNotification): void {
    const current = this.notificationsSubject.value;
    this.notificationsSubject.next([notification, ...current]);
    this.updateUnreadCount();
    // Broadcast for toast
    this.toastSubject.next(notification);
  }
  
  clearToast(): void {
    this.toastSubject.next(null);
  }

  private updateUnreadCount(): void {
    const count = this.notificationsSubject.value.filter(n => !n.isRead).length;
    this.unreadCountSubject.next(count);
  }
}
